<template>
	<div id="page-content" class="supplier-sidebar">
		<div class="pcsp">
			<h1>Account Information - {{user.username}}</h1>

			<div class="row">

				<div class="col-md-4">
					<h2>Basic Information</h2>
					<p>Name: {{user.name}}</p>
					<p>Account-Type: Buyer</p>
					<p v-if="!showpw">Password: <button type="button" class="button-type-e" @click.prevent="ShowChangePW">Change</button></p>


					<form v-if="showpw" id="changePassword" @submit.prevent="ChangePassword">
						<label for="old_pw">Enter Old Password</label>
						<input type="password" name="old_pw" id="old_pw"/>

						<label for="new_pw">Enter New Password</label>
						<input type="password" name="new_pw" id="new_pw"/>

						<label for="confirm_new_pw">Confirm New Password</label>
						<input type="password" name="confirm_new_pw" id="confirm_new_pw"/>

						<input type="hidden" name="token" v-bind:value="changepwtoken" />
						<button type="submit" class="floatright button-type-e">Save</button>
					</form>


					
				</div>

				<div class="col-md-4">
					<h2>Contact Information</h2>
					<p>Email: {{ user.email }}</p>
					<p v-if="!showmb">Mobile #: {{user.mobile_number}} <button type="button" class="button-type-e" @click.prevent="ShowChangeMB">Change</button></p>

					<form v-if="showmb" id="changeMobile" @submit.prevent="ChangeMobile">
						<label for="new_mb">Enter New Mobile Number</label>
						<input type="text" name="new_mb" id="new_mb" />
						<!-- <input type="hidden" name="changembtoken" v-bind:value="changembtoken"> -->
						<button type="submit" class="floatright button-type-e">Save</button>
					</form>
				</div>

				

			</div>
		</div>

		<!-- notification type -->
		<transition name="fade">
			<div class="notification-b" v-if="notification">
				<p v-text="notificationMessage"></p>
				<span></span>
			</div>
		</transition>
		<!-- notification type -->

	</div>
</template>

<script>
	export default{
		props: ['issessionset', 'user'],
		data(){
			return{
				showpw: false,
				showmb: false,
				//multi-request CSRF protection experiment
				changepwtoken: '',
				changembtoken: '',

				notification: false,
				notificationMessage: ''
			}
		},
		methods: {
			ShowChangePW: function(event){
				this.GetPWToken();
				this.showpw = true;
			},
			ChangePassword: function(event){
				var self = this;
				var data = $(event.target).serialize();
				$.ajax({
					url: 'static/php/changepassword.php',
					type: 'POST',
					data: data,
					success: function(data){
						
						console.log(data);
						if(data == true){
							self.notification = true;
							self.notificationMessage = 'Password Changed';
							setTimeout(function(){
								self.notification = false;
								self.notificationMessage = '';
							}, 3000);
						}else{
							alert(data);	
						}

					}
				});
				this.showpw = false;
				this.changepwtoken = '';
			},
			GetPWToken: function(){
				var self = this;
				$.ajax({
					url: 'static/php/gettoken.php',
					success: function(data){
						if(typeof data === "string"){
							self.changepwtoken = data;						
						}
					}
				});
			},
			ShowChangeMB: function(event){
				this.showmb = true;
			},
			ChangeMobile: function(event){
				var self = this;
				var data  = $(event.target).serialize();
				$.ajax({
					url: 'static/php/changemobile.php',
					type: 'POST',
					data: data,
					success: function(data){
						alert(data);
						self.showmb = false;
						self.changembtoken = '';
						location.reload();
					}
				});
			}
		},
		created(){
			if(this.issessionset === false){
				this.$router.push({path: '/login'});
			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		},
		watch: {
			issessionset: function(newval){
				if(newval === false){
					this.$router.push({path: '/login'});
				}
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// UserAccount.vue?7a7ece5c